import { type Editor } from "@tiptap/react";
import { type Ref, useImperativeHandle } from "react";

import { type TemplateEditorInsertHandle } from "./RichTemplateEditor.types";

// `^{{...}}$` (lazy `+`, без `{`/`}` внутри path) — отличает «вставка ровно
// одной переменной из сайдбара» от обычной пастой текста. Lazy + negated
// class — ReDoS-safe.
const PLACEHOLDER_INSERT_REGEX = /^\{\{\s*([^{}]+?)\s*\}\}$/;

/**
 * Прокидывает наружу `insertAtCursor` / `focus`. `insertAtCursor` сам решает:
 * если строка — литерал `{{path}}`, вставляем atom-ноду PlaceholderNode
 * (получится чип); иначе вставляем как обычный текст.
 */
export const useRichEditorHandle = (
  ref: Ref<TemplateEditorInsertHandle>,
  editor: Editor | null,
) => {
  useImperativeHandle(
    ref,
    () => ({
      insertAtCursor(text: string) {
        if (!editor) return;
        const match = text.match(PLACEHOLDER_INSERT_REGEX);
        if (match) {
          editor
            .chain()
            .focus()
            .insertContent({
              type: "placeholder",
              attrs: { path: match[1].trim() },
            })
            .run();
        } else {
          editor.chain().focus().insertContent(text).run();
        }
      },
      focus() {
        editor?.commands.focus();
      },
    }),
    [editor],
  );
};
